import { LocalStorageKeys } from "@/components/pages/login/hooks/useLocalStorage";

export const useIsAuthenticated = () => {
  const token = localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN);
  return !!token;
};
